import { Image, Skeleton } from '@round/creatorbase-ui';
import { ReactNode } from 'react';

import Accounts from '../Accounts/Accounts';
import { ClientInfluencerAccount } from '../helpers';

import styles from './CompactHeader.module.css';
import cn from 'classnames';
import AddCreatorToCampaignsDropdown from '../../AddCreatorToCampaignsDropdown/AddCreatorToCampaignsDropdown';
import { creatorbase } from '@round/api';

export type CompactHeaderProps = {
    account: ClientInfluencerAccount | undefined;
    clientInfluencer: creatorbase.ClientInfluencer | undefined;
    image: string | undefined;
    isImageLoading: boolean;
    accounts: ClientInfluencerAccount[];
    activeAccountId: number | undefined;
    onSelectAccount: (accountId: number) => void;
    isAccountsLoading: boolean;
    toolbar?: ReactNode;
    className?: string;
};

const CompactHeader = ({
    account,
    image,
    isImageLoading,
    accounts,
    activeAccountId,
    onSelectAccount,
    isAccountsLoading,
    toolbar,
    className,
    clientInfluencer,
}: CompactHeaderProps) => {
    return (
        <div className={cn(styles.root, className)}>
            <Image
                src={image ?? ''}
                alt={account?.full_name ?? ''}
                isLoading={isAccountsLoading || isImageLoading}
                className={styles.avatar}
            />

            {isAccountsLoading ? (
                <Skeleton className={styles.nameSkeleton} aria-busy="true" aria-label="Loading creator name" />
            ) : (
                <h2 className={styles.name}>{account?.full_name}</h2>
            )}

            <div className={styles.accounts}>
                <Accounts
                    accounts={accounts}
                    activeAccountId={activeAccountId}
                    onSelectAccount={onSelectAccount}
                    isLoading={isAccountsLoading}
                />
            </div>

            {toolbar ? (
                <div className={styles.toolbar}>{toolbar}</div>
            ) : (
                <div className={styles.toolbar}>
                    <AddCreatorToCampaignsDropdown
                        accountId={account?.creatorbase_client_influencer_account_id}
                        platform={account?.platform}
                        clientInfluencer={clientInfluencer}
                    />
                </div>
            )}
        </div>
    );
};

export default CompactHeader;
